import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class AddSubject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: "",
      },
      subjectError: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = (subject) => {
    let subjectError = subject ? subject : "";

    if (subjectError) {
      this.setState({
        subjectError,
      });
      return false;
    } else {
      this.setState({
        subjectError: "",
      });
      return true;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      if (this.props.editStatus) {
        const editResponse = await Axios.put(
          `${url}/api/subjects/${this.props.subjectId}`,
          this.state.data,
          { headers: { Authorization: `Bearer ${this.props.adminToken}` } }
        );
        if (editResponse.data.message === "class edited successfully") {
          this.props.history.push(`/administration/class`);
        }
      } else {
        const response = await Axios.post(
          `${url}/api/subjects`,
          this.state.data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Subject added successfully") {
          this.setState({
            data: { name: "" },
            subjectError: "",
            loading: false,
          });
          this.props.getSubjects();
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      if (error.response.status === 409) {
        console.clear();
        this.checkError("Subject already stored");
      }
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Paper className={classes.paper}>
          <form onSubmit={this.handleSubmit}>
            <div>
              <TextField
                name="name"
                type="text"
                label="Subject Name"
                required
                fullWidth
                variant="outlined"
                margin="normal"
                error={this.state.subjectError ? true : false}
                helperText={
                  this.state.subjectError
                    ? this.state.subjectError
                    : "E.g English or Nepali or Physics "
                }
                placeholder="Enter the name of subject"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.name}
                onChange={this.handleChange}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                aria-label="Submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                Submit
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddSubject)));
